var _rect, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _path7, _circle, _circle2, _circle3, _path8, _g3, _rect2, _path9, _path10, _path11, _path12, _path13, _path14, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _g5, _path21, _g6, _g7, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 171,
    viewBox: "0 0 324 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_15959)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "url(#paint0_linear_359_15959)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M366.193 23.5383C386.615 51.7683 373.735 94.5986 337.753 120.628C301.868 146.587 258.295 144.264 237.819 115.957C217.235 87.5034 227.222 41.9449 262.929 16.1151C298.637 -9.7156 345.611 -4.91448 366.193 23.5383Z",
    stroke: "url(#paint1_linear_359_15959)",
    strokeWidth: 6.46129
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.199 8.87626C389.994 44.1854 382.299 86.8792 340.85 120.517C298.173 151.985 251.879 144.394 227.546 113.444C203.212 82.4934 212.137 31.0455 249.926 3.70892C287.716 -23.6277 337.781 -22.1135 360.199 8.87626Z",
    fill: "url(#paint2_linear_359_15959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.843 8.05579C366.079 22.2062 367.773 40.0091 362.24 57.7807C356.7 75.576 343.933 93.1871 325.555 106.482C288.59 133.222 244.246 131.37 223.811 103.12C203.271 74.7264 213.96 28.5691 250.745 1.95905C287.531 -24.6519 335.304 -20.337 355.843 8.05579Z",
    stroke: "url(#paint3_linear_359_15959)",
    strokeWidth: 6.46129
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.59 8.10005C364.519 31.5027 355.012 71.7831 319.573 97.4199C284.133 123.057 242.9 119.481 225.971 96.0783C209.042 72.6756 218.549 32.3953 253.989 6.75843C289.428 -18.8784 330.661 -15.3026 347.59 8.10005Z",
    fill: "#F6D971",
    stroke: "url(#paint4_linear_359_15959)",
    strokeWidth: 17.948
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.108 88.4702L254.601 61.2299L317.656 69.0684L291.108 88.4702Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M254.196 60.7696L301.211 34.6L290.53 87.4742L254.196 60.7696Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_359_15959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.653 47.9454C280.062 45.5357 283.01 43.1966 296.218 36.9291C290.252 41.1459 280.469 46.6541 276.653 47.9454Z",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_359_15959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.256 84.1709C273.272 73.7245 269.452 61.0866 272.321 50.4965C282.34 55.8125 287.675 78.3943 285.256 84.1709Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.256 84.1709C273.272 73.7245 269.452 61.0866 272.321 50.4965C282.34 55.8125 287.675 78.3943 285.256 84.1709Z",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M253.341 60.7148L284.723 83.7799L263.931 29.585L253.341 60.7148Z",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.925714
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 301.403,
    cy: 33.7749,
    r: 4.05936,
    transform: "rotate(36.3143 301.403 33.7749)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317.193,
    cy: 69.1391,
    r: 3.39924,
    transform: "rotate(36.3143 317.193 69.1391)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.15,
    cy: 30.155,
    r: 3.39924,
    transform: "rotate(-8.68571 264.15 30.155)",
    fill: "#2C2C2C",
    stroke: "#F6D971",
    strokeWidth: 0.462857
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.91 14.4083C346.197 24.4827 347.156 37.85 342.578 51.456C338.001 65.0586 327.915 78.7753 313.354 89.3093C298.792 99.8433 282.608 105.13 268.256 105.22C253.901 105.31 241.505 100.216 234.217 90.1421C226.929 80.0677 225.97 66.7003 230.549 53.0944C235.126 39.4917 245.211 25.775 259.773 15.241C274.335 4.70705 290.519 -0.579367 304.871 -0.66974C319.226 -0.760135 331.622 4.33388 338.91 14.4083Z",
    stroke: "url(#paint5_linear_359_15959)",
    strokeWidth: 2.87168
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_359_15959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.786 47.728L378.339 64.547C381.609 45.3291 374.459 29.9472 371.649 25.68C369.426 21.5115 365.3 15.656 360.441 9.23124C347.545 -10.9302 320.36 -28.912 278.102 -15.4846C227.842 1.80048 211.182 42.5319 209.395 60.5175L363.489 45.7588L367.786 47.728Z",
    fill: "#FEFFFE",
    fillOpacity: 0.22
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dddddd_359_15959)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_359_15959)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5142,
    y: 27.5146,
    width: 37.0286,
    height: 37.0286,
    rx: 18.5143,
    fill: "#1B1A1A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dddddd_359_15959)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1289 45.4113L36.5346 35.8896L33.3607 45.4113H29.1289Z",
    fill: "url(#paint6_linear_359_15959)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3604 45.4113L36.5342 35.8896L39.7081 45.4113H33.3604Z",
    fill: "url(#paint7_linear_359_15959)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5347 35.8896L39.7085 45.4113H43.9404L36.5347 35.8896Z",
    fill: "url(#paint8_linear_359_15959)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5346 54.9318L29.1289 45.4102H33.3607L36.5346 54.9318Z",
    fill: "url(#paint9_linear_359_15959)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7081 45.4102H33.3604L36.5342 54.9318L39.7081 45.4102Z",
    fill: "url(#paint10_linear_359_15959)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7085 45.4102H43.9404L36.5347 54.9318L39.7085 45.4102Z",
    fill: "url(#paint11_linear_359_15959)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_359_15959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1289 45.4113L36.5346 35.8896L33.3607 45.4113H29.1289Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5346 35.8896L39.7085 45.4113H43.9403L36.5346 35.8896Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3607 45.4113L36.5346 35.8896L39.7085 45.4113H33.3607Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5346 54.9329L29.1289 45.4113H33.3607L36.5346 54.9329Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7085 45.4113H43.9403L36.5346 54.9329L39.7085 45.4113Z",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7085 45.4113H33.3607L36.5346 54.9329L39.7085 45.4113Z",
    fill: "white",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_359_15959)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_359_15959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 35,
    width: 15,
    height: 20
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1289 45.4113L36.5346 35.8896L33.3607 45.4113H29.1289Z",
    fill: "url(#paint12_linear_359_15959)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5346 35.8896L39.7085 45.4113H43.9403L36.5346 35.8896Z",
    fill: "url(#paint13_linear_359_15959)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3607 45.4113L36.5346 35.8896L39.7085 45.4113H33.3607Z",
    fill: "url(#paint14_linear_359_15959)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5346 54.9329L29.1289 45.4113H33.3607L36.5346 54.9329Z",
    fill: "url(#paint15_linear_359_15959)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7085 45.4113H43.9403L36.5346 54.9329L39.7085 45.4113Z",
    fill: "url(#paint16_linear_359_15959)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7085 45.4113H33.3607L36.5346 54.9329L39.7085 45.4113Z",
    fill: "url(#paint17_linear_359_15959)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_359_15959)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_359_15959)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5569 35.8967L33.383 45.4183L33.3384 45.4035L36.5123 35.8818L36.5569 35.8967Z",
    fill: "url(#paint18_linear_359_15959)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5122 54.925L39.6861 45.4033L39.7307 45.4182L36.5568 54.9398L36.5122 54.925Z",
    fill: "url(#paint19_linear_359_15959)"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_359_15959)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_359_15959",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 35,
    width: 7,
    height: 11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4874 35.8896L33.3135 45.329H39.7435L36.4874 35.8896Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.0235102
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_359_15959)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 56.4023,
    y: 5.67871,
    width: 1.37876,
    height: 75.1718,
    transform: "rotate(30.433 56.4023 5.67871)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.4771,
    y: 8.70898,
    width: 2.0372,
    height: 72.8653,
    transform: "rotate(30.433 57.4771 8.70898)",
    fill: "white",
    fillOpacity: 0.2
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_359_15959)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5348,
    cy: 36.6046,
    rx: 0.52898,
    ry: 0.714949,
    fill: "url(#paint20_linear_359_15959)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4816 52.7126C70.6263 52.7126 69.8209 52.5571 69.0655 52.246C68.3212 51.935 67.6714 51.5073 67.1159 50.963C66.5605 50.4076 66.1217 49.7633 65.7996 49.0301C65.4885 48.2858 65.333 47.486 65.333 46.6306C65.333 45.7753 65.4941 44.981 65.8162 44.2479C66.1384 43.5147 66.5827 42.8759 67.1493 42.3316C67.7269 41.7762 68.399 41.3485 69.1655 41.0486C69.932 40.7375 70.754 40.582 71.6316 40.582C72.6425 40.582 73.5589 40.7653 74.3809 41.1319C75.2141 41.4985 75.9028 42.0039 76.4471 42.6482L74.6642 44.4311C74.2865 43.9424 73.8422 43.5758 73.3312 43.3314C72.8202 43.087 72.2425 42.9648 71.5983 42.9648C70.9095 42.9648 70.293 43.1203 69.7487 43.4314C69.2044 43.7313 68.7767 44.159 68.4656 44.7144C68.1657 45.2587 68.0157 45.8975 68.0157 46.6306C68.0157 47.3638 68.1657 48.0081 68.4656 48.5635C68.7656 49.119 69.1766 49.5522 69.6987 49.8632C70.2208 50.1743 70.8207 50.3298 71.4983 50.3298C72.187 50.3298 72.7702 50.2021 73.2479 49.9466C73.7367 49.6799 74.1088 49.3023 74.3643 48.8135C74.6309 48.3136 74.7642 47.7082 74.7642 46.9972L76.4971 48.1636L71.2483 48.0803V45.8642H77.4303V46.2474C77.4303 47.6582 77.1748 48.8468 76.6638 49.8133C76.1639 50.7686 75.464 51.4906 74.5642 51.9794C73.6756 52.4682 72.648 52.7126 71.4816 52.7126ZM82.6817 52.7126C81.8485 52.7126 81.0931 52.5293 80.4155 52.1627C79.749 51.785 79.2213 51.274 78.8325 50.6297C78.4437 49.9854 78.2493 49.2634 78.2493 48.4636C78.2493 47.6637 78.4437 46.9472 78.8325 46.3141C79.2213 45.6809 79.749 45.181 80.4155 44.8144C81.082 44.4367 81.8374 44.2479 82.6817 44.2479C83.5259 44.2479 84.2813 44.4311 84.9478 44.7977C85.6143 45.1643 86.142 45.6698 86.5308 46.3141C86.9196 46.9472 87.114 47.6637 87.114 48.4636C87.114 49.2634 86.9196 49.9854 86.5308 50.6297C86.142 51.274 85.6143 51.785 84.9478 52.1627C84.2813 52.5293 83.5259 52.7126 82.6817 52.7126ZM82.6817 50.3965C83.0482 50.3965 83.3704 50.3187 83.6481 50.1632C83.9258 49.9965 84.1369 49.7688 84.2813 49.48C84.4368 49.1801 84.5146 48.8413 84.5146 48.4636C84.5146 48.0859 84.4368 47.7582 84.2813 47.4805C84.1258 47.1916 83.9092 46.9695 83.6314 46.8139C83.3648 46.6473 83.0482 46.564 82.6817 46.564C82.3262 46.564 82.0096 46.6473 81.7319 46.8139C81.4542 46.9695 81.2375 47.1916 81.082 47.4805C80.9265 47.7693 80.8487 48.1025 80.8487 48.4802C80.8487 48.8468 80.9265 49.1801 81.082 49.48C81.2375 49.7688 81.4542 49.9965 81.7319 50.1632C82.0096 50.3187 82.3262 50.3965 82.6817 50.3965ZM88.3832 52.5293V40.4321H90.9326V52.5293H88.3832ZM96.1771 52.6959C95.4106 52.6959 94.7275 52.5126 94.1276 52.1461C93.5389 51.7795 93.0723 51.2796 92.7279 50.6464C92.3947 50.0132 92.228 49.2911 92.228 48.4802C92.228 47.6693 92.3947 46.9472 92.7279 46.3141C93.0723 45.6809 93.5389 45.181 94.1276 44.8144C94.7275 44.4478 95.4106 44.2645 96.1771 44.2645C96.7326 44.2645 97.2325 44.3701 97.6768 44.5811C98.1322 44.7922 98.5044 45.0866 98.7932 45.4642C99.0931 45.8308 99.2598 46.253 99.2931 46.7306V50.1465C99.2598 50.6242 99.0987 51.0574 98.8099 51.4462C98.521 51.8239 98.1489 52.1294 97.6935 52.3627C97.238 52.5848 96.7326 52.6959 96.1771 52.6959ZM96.627 50.3965C96.9936 50.3965 97.3102 50.3187 97.5768 50.1632C97.8434 49.9965 98.0545 49.7688 98.21 49.48C98.3655 49.1912 98.4433 48.8579 98.4433 48.4802C98.4433 48.1025 98.3655 47.7748 98.21 47.4971C98.0656 47.2083 97.8545 46.9806 97.5768 46.8139C97.3102 46.6473 96.9992 46.564 96.6437 46.564C96.2882 46.564 95.9716 46.6473 95.6939 46.8139C95.4273 46.9806 95.2107 47.2083 95.0441 47.4971C94.8885 47.7859 94.8108 48.1136 94.8108 48.4802C94.8108 48.8468 94.8885 49.1745 95.0441 49.4633C95.1996 49.7522 95.4162 49.9799 95.6939 50.1465C95.9716 50.3131 96.2827 50.3965 96.627 50.3965ZM100.843 52.5293H98.3433V50.3465L98.7266 48.3802L98.2933 46.414V40.4321H100.843V52.5293ZM106.044 52.5293V40.7653H107.91L112.543 47.9803H111.593L116.208 40.7653H118.091V52.5293H115.475V45.181L115.942 45.2976L112.926 49.9965H111.193L108.194 45.2976L108.644 45.181V52.5293H106.044ZM124.113 52.7126C123.236 52.7126 122.453 52.5349 121.764 52.1794C121.086 51.8128 120.553 51.3074 120.164 50.6631C119.775 50.0188 119.581 49.2911 119.581 48.4802C119.581 47.6693 119.77 46.9472 120.148 46.3141C120.536 45.6698 121.058 45.1643 121.714 44.7977C122.369 44.4311 123.108 44.2479 123.93 44.2479C124.73 44.2479 125.435 44.42 126.046 44.7644C126.657 45.1088 127.135 45.5864 127.479 46.1974C127.835 46.8084 128.012 47.5082 128.012 48.2969C128.012 48.4413 128.001 48.5969 127.979 48.7635C127.968 48.919 127.94 49.1023 127.896 49.3134L120.914 49.33V47.5804L126.813 47.5638L125.713 48.2969C125.702 47.8304 125.63 47.4471 125.496 47.1472C125.363 46.8362 125.163 46.6029 124.896 46.4474C124.641 46.2807 124.324 46.1974 123.947 46.1974C123.547 46.1974 123.197 46.2918 122.897 46.4807C122.608 46.6584 122.38 46.9139 122.214 47.2472C122.058 47.5804 121.98 47.9859 121.98 48.4636C121.98 48.9412 122.064 49.3522 122.23 49.6966C122.408 50.0299 122.653 50.2909 122.964 50.4798C123.286 50.6575 123.663 50.7464 124.097 50.7464C124.497 50.7464 124.858 50.6797 125.18 50.5464C125.502 50.402 125.785 50.1909 126.03 49.9132L127.429 51.3129C127.029 51.7795 126.546 52.1294 125.98 52.3627C125.413 52.5959 124.791 52.7126 124.113 52.7126ZM129.243 52.5293V44.4311H131.792V52.5293H129.243ZM134.425 52.5293V47.797C134.425 47.386 134.297 47.0694 134.042 46.8473C133.798 46.614 133.492 46.4973 133.125 46.4973C132.87 46.4973 132.642 46.5529 132.442 46.664C132.242 46.7639 132.081 46.9084 131.959 47.0972C131.848 47.2861 131.792 47.5193 131.792 47.797L130.809 47.3638C130.809 46.7195 130.948 46.1696 131.226 45.7142C131.504 45.2476 131.881 44.8922 132.359 44.6478C132.837 44.3923 133.375 44.2645 133.975 44.2645C134.542 44.2645 135.047 44.3923 135.492 44.6478C135.947 44.9033 136.308 45.2587 136.575 45.7142C136.841 46.1696 136.975 46.714 136.975 47.3471V52.5293H134.425ZM139.607 52.5293V47.797C139.607 47.386 139.48 47.0694 139.224 46.8473C138.98 46.614 138.674 46.4973 138.308 46.4973C138.052 46.4973 137.824 46.5529 137.624 46.664C137.424 46.7639 137.263 46.9084 137.141 47.0972C137.03 47.2861 136.975 47.5193 136.975 47.797L135.508 47.5971C135.53 46.9084 135.692 46.3196 135.991 45.8308C136.303 45.3309 136.708 44.9477 137.208 44.6811C137.719 44.4034 138.291 44.2645 138.924 44.2645C139.546 44.2645 140.096 44.3978 140.574 44.6644C141.063 44.9199 141.446 45.2921 141.723 45.7808C142.012 46.2585 142.157 46.8362 142.157 47.5138V52.5293H139.607ZM148.456 52.6959C147.912 52.6959 147.412 52.5848 146.956 52.3627C146.501 52.1294 146.129 51.8239 145.84 51.4462C145.551 51.0574 145.385 50.6242 145.34 50.1465V46.7306C145.385 46.253 145.551 45.8308 145.84 45.4642C146.129 45.0866 146.501 44.7922 146.956 44.5811C147.412 44.3701 147.912 44.2645 148.456 44.2645C149.223 44.2645 149.9 44.4478 150.489 44.8144C151.089 45.181 151.555 45.6809 151.889 46.3141C152.233 46.9472 152.405 47.6693 152.405 48.4802C152.405 49.2911 152.233 50.0132 151.889 50.6464C151.555 51.2796 151.089 51.7795 150.489 52.1461C149.9 52.5126 149.223 52.6959 148.456 52.6959ZM148.006 50.3965C148.362 50.3965 148.673 50.3131 148.939 50.1465C149.217 49.9799 149.434 49.7522 149.589 49.4633C149.745 49.1745 149.822 48.8468 149.822 48.4802C149.822 48.1025 149.745 47.7693 149.589 47.4805C149.434 47.1916 149.217 46.9695 148.939 46.8139C148.673 46.6473 148.362 46.564 148.006 46.564C147.651 46.564 147.334 46.6473 147.056 46.8139C146.779 46.9695 146.562 47.1916 146.407 47.4805C146.262 47.7693 146.19 48.1025 146.19 48.4802C146.19 48.8579 146.268 49.1912 146.423 49.48C146.579 49.7688 146.79 49.9965 147.056 50.1632C147.334 50.3187 147.651 50.3965 148.006 50.3965ZM143.79 52.5293V40.4321H146.34V46.414L145.923 48.3802L146.307 50.3465V52.5293H143.79ZM157.699 52.7126C156.822 52.7126 156.039 52.5349 155.35 52.1794C154.672 51.8128 154.139 51.3074 153.75 50.6631C153.362 50.0188 153.167 49.2911 153.167 48.4802C153.167 47.6693 153.356 46.9472 153.734 46.3141C154.122 45.6698 154.645 45.1643 155.3 44.7977C155.955 44.4311 156.694 44.2479 157.516 44.2479C158.316 44.2479 159.021 44.42 159.632 44.7644C160.243 45.1088 160.721 45.5864 161.065 46.1974C161.421 46.8084 161.599 47.5082 161.599 48.2969C161.599 48.4413 161.587 48.5969 161.565 48.7635C161.554 48.919 161.526 49.1023 161.482 49.3134L154.5 49.33V47.5804L160.399 47.5638L159.299 48.2969C159.288 47.8304 159.216 47.4471 159.082 47.1472C158.949 46.8362 158.749 46.6029 158.483 46.4474C158.227 46.2807 157.91 46.1974 157.533 46.1974C157.133 46.1974 156.783 46.2918 156.483 46.4807C156.194 46.6584 155.966 46.9139 155.8 47.2472C155.644 47.5804 155.567 47.9859 155.567 48.4636C155.567 48.9412 155.65 49.3522 155.816 49.6966C155.994 50.0299 156.239 50.2909 156.55 50.4798C156.872 50.6575 157.25 50.7464 157.683 50.7464C158.083 50.7464 158.444 50.6797 158.766 50.5464C159.088 50.402 159.371 50.1909 159.616 49.9132L161.015 51.3129C160.615 51.7795 160.132 52.1294 159.566 52.3627C158.999 52.5959 158.377 52.7126 157.699 52.7126ZM162.829 52.5293V44.4311H165.379V52.5293H162.829ZM165.379 48.0803L164.312 47.2472C164.523 46.3029 164.879 45.5698 165.379 45.0477C165.878 44.5256 166.573 44.2645 167.461 44.2645C167.85 44.2645 168.189 44.3256 168.478 44.4478C168.778 44.5589 169.039 44.7366 169.261 44.981L167.745 46.8973C167.634 46.7751 167.495 46.6806 167.328 46.614C167.161 46.5473 166.973 46.514 166.762 46.514C166.339 46.514 166.001 46.6473 165.745 46.9139C165.501 47.1694 165.379 47.5582 165.379 48.0803Z",
    fill: "#2C2C2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_359_15959",
    x: 274.534,
    y: 34.6593,
    width: 23.803,
    height: 15.5759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.925714,
    result: "effect1_foregroundBlur_359_15959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_359_15959",
    x: 261.692,
    y: 40.5593,
    width: 33.8624,
    height: 53.6393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.62857,
    result: "effect1_foregroundBlur_359_15959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_359_15959",
    x: 206.523,
    y: -23.0006,
    width: 175.527,
    height: 90.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.43584,
    result: "effect1_foregroundBlur_359_15959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dddddd_359_15959",
    x: -94.0527,
    y: -10.9951,
    width: 262.163,
    height: 262.162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.04935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.55751
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.037943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.92488
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.74291
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0479222 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_359_15959",
    result: "effect2_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.2731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.04756
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0544001 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_359_15959",
    result: "effect3_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.5416
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5716
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0602938 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_359_15959",
    result: "effect4_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.9393
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.5139
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.0681504 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_359_15959",
    result: "effect5_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 74.0571
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 56.2834
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_359_15959",
    result: "effect6_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_359_15959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dddddd_359_15959",
    x: -30.1168,
    y: 35.8896,
    width: 133.797,
    height: 152.963,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.04935
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.819741
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.0787208 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.92488
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.96995
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.11309 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_359_15959",
    result: "effect2_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.2731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.70924
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_359_15959",
    result: "effect3_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.5416
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.61665
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.16691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_359_15959",
    result: "effect4_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.9393
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3757
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.201279 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_359_15959",
    result: "effect5_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 74.0572
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29.6229
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.278431 0 0 0 0 0.278431 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_359_15959",
    result: "effect6_dropShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_359_15959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_359_15959",
    x: 29.1289,
    y: 35.7016,
    width: 14.8115,
    height: 19.4426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.211592
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188082
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_359_15959"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.188082
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.576
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_359_15959",
    result: "effect2_innerShadow_359_15959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_359_15959",
    x: 32.398,
    y: 34.9414,
    width: 5.09908,
    height: 11.4169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.470204
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_359_15959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_359_15959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_359_15959",
    x: 32.7492,
    y: 35.3254,
    width: 7.55867,
    height: 10.5679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.282122,
    result: "effect1_foregroundBlur_359_15959"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_359_15959",
    x: 34.9479,
    y: 34.8317,
    width: 3.17402,
    height: 3.54561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.52898,
    result: "effect1_foregroundBlur_359_15959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_15959",
    x1: 255.723,
    y1: 31.5201,
    x2: 207.49,
    y2: 202.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_15959",
    x1: 364.652,
    y1: 15.8192,
    x2: 254.279,
    y2: 139.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_15959",
    x1: 362.756,
    y1: 16.627,
    x2: 240.736,
    y2: 139.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEBB5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#FDEE48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#E8BB06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#D57B01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#C86101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660555,
    stopColor: "#D88C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771761,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815114,
    stopColor: "#E8BE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881945,
    stopColor: "#E8AE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930202,
    stopColor: "#D98317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBAE4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_359_15959",
    x1: 354.302,
    y1: 0.336062,
    x2: 241.786,
    y2: 128.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF8CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0550575,
    stopColor: "#F2E158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.170676,
    stopColor: "#FCF5AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309086,
    stopColor: "#ECD42F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491314,
    stopColor: "#E9B00C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704021,
    stopColor: "#ECB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78935,
    stopColor: "#E8CF29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843399,
    stopColor: "#EBD431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.909367,
    stopColor: "#E2C317"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9D14F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_359_15959",
    x1: 318.477,
    y1: -20.9744,
    x2: 263.751,
    y2: 125.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417119,
    stopColor: "#FFED97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_359_15959",
    x1: 259.654,
    y1: 11.132,
    x2: 318.57,
    y2: 89.1705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4991A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474971,
    stopColor: "#EAAA2E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF27B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_359_15959",
    x1: 34.974,
    y1: 37.6142,
    x2: 30.1534,
    y2: 44.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_359_15959",
    x1: 38.3704,
    y1: 37.6142,
    x2: 33.3338,
    y2: 43.8651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_359_15959",
    x1: 42.3798,
    y1: 37.6142,
    x2: 37.5592,
    y2: 44.5941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_359_15959",
    x1: 34.974,
    y1: 47.1348,
    x2: 30.1534,
    y2: 54.1146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_359_15959",
    x1: 38.3704,
    y1: 47.1348,
    x2: 33.3338,
    y2: 53.3856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_359_15959",
    x1: 42.3798,
    y1: 47.1348,
    x2: 37.5592,
    y2: 54.1146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_359_15959",
    x1: 43.9403,
    y1: 35.8896,
    x2: 24.5883,
    y2: 43.7406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_359_15959",
    x1: 29.1289,
    y1: 35.8896,
    x2: 48.4811,
    y2: 43.7393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_359_15959",
    x1: 36.5346,
    y1: 35.8896,
    x2: 36.5346,
    y2: 54.9329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_359_15959",
    x1: 29.1289,
    y1: 35.8896,
    x2: 43.2581,
    y2: 55.4263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_359_15959",
    x1: 43.9403,
    y1: 35.8896,
    x2: 29.8111,
    y2: 55.4263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_359_15959",
    x1: 36.5346,
    y1: 45.4113,
    x2: 35.3476,
    y2: 54.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#047857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_359_15959",
    x1: 36.5346,
    y1: 35.8893,
    x2: 33.3607,
    y2: 45.4109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EE7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_359_15959",
    x1: 39.0525,
    y1: 47.1306,
    x2: 34.4013,
    y2: 50.0528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8B71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F6DC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#F5CF63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#CA9D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B67F12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_359_15959",
    x1: 36.5348,
    y1: 35.8896,
    x2: 36.5348,
    y2: 37.3195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_15959"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.668945,
    width: 324,
    height: 170.331,
    rx: 12.0343,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_359_15959"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5142,
    y: 27.5146,
    width: 37.0286,
    height: 37.0286,
    rx: 18.5143,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_359_15959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8114,
    height: 19.0433,
    fill: "white",
    transform: "translate(29.1289 35.8896)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldMember);
export default __webpack_public_path__ + "static/media/gold_member.35cd00450f2dbbf46024ffbe0a467ef2.svg";
export { ForwardRef as ReactComponent };